<template>
  <VContainer class="py-10">
    <h1 class="font-bold text-xl mb-8">{{ t('Reset Password') }}</h1>
    <div class="mb-4 max-w-4xl" v-if="data.message || (Array.isArray(data.psdata) && data.psdata.length)">
      <div class="p-4 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="w-5 h-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-red-800">
              {{ t('Password reset failed') }}
            </h3>
            <div class="mt-2 text-sm text-red-700">
              <div v-if="data.message">
                <p>{{ data.message }}</p>
              </div>
              <div v-else-if="Array.isArray(data.psdata)">
                <p v-for="message in data.psdata" :key="message">{{ message }}</p>
              </div>
              <div v-else>
                <p>{{ t('Password reset email not found') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FormKit type="form" class="pb-4 md:p-6 mt-10 md:border md:border-neutral-200 rounded-md" @submit="submitForm">
      <FormKit
        name="email"
        v-model="customerEmail"
        :label="t('Email')"
        type="email"
        :errors="data.psdata?.email"
        :rules="['required']"
      />
    </FormKit>
  </VContainer>
</template>

<script setup lang="ts">
import { useSdk } from '~/sdk';

const { t } = useI18n();
const localePath = useLocalePath();
const customerEmail = ref('');
const data = ref<any>({});

async function submitForm() {
  let res = await useSdk().commerce.resetPasswordEmail({
    email: customerEmail.value,
  });

  if (res.success) {
    await navigateTo(localePath(`/reset-password-success?email=${encodeURIComponent(customerEmail.value)}`));
    return;
  }

  data.value = res;
}

useSeoMeta({ title: t('Reset password') });
</script>
